let sectionSlider = document.querySelector('.section-slider')

if(sectionSlider) {
    new Swiper(sectionSlider, {
        slidesPerView: 1,
        slideClass: 'image',
        spaceBetween: 30,
        speed: 600,
        loop: true,
        autoplay: {
            delay: 2200,
        },
    })
}

///

// let officesSlider = document.querySelector('.offices-line')

// if(officesSlider) {
//     console.log(officesSlider);
//     new Swiper(officesSlider, {
//         slidesPerView: 1,
//         slideClass: 'office',
//         spaceBetween: 15,
//         breakpoints: {
//             768: {
//                 slidesPerView: 3,
//             },
//             1025: {
//                 slidesPerView: 4,
//             }
//         }
//     })
// }